<template>
  <div aria-orientation="horizontal" class="el-slider" aria-valuetext="0">
    <div class="el-slider__runway" ref="slider">
      <div
        class="el-slider__bar"
        :style="{left: leftPosition+'%' ,right: (100 - rightPosition)+'%'}"
      ></div>
      <div tabindex="0" class="el-slider__button-wrapper" :style="{left: leftPosition+'%'}">
        <div
          class="el-tooltip el-slider__button"
          aria-describedby="el-tooltip-6137"
          tabindex="0"
          @touchstart="onButtonDowm"
          @mousedown="onButtonDowm"
          id="slider-left"
        ></div>
        <div class="tips" v-if="dragging && targetEle.id==='slider-left'">{{posiObj.left}}</div>
      </div>
      <div tabindex="0" class="el-slider__button-wrapper" :style="{left: rightPosition+'%'}">
        <div
          class="el-tooltip el-slider__button"
          aria-describedby="el-tooltip-6137"
          tabindex="0"
          @touchstart="onButtonDowm"
          @mousedown="onButtonDowm"
          id="slider-right"
        ></div>
        <div class="tips" v-if="dragging && targetEle.id==='slider-right'">{{posiObj.right}}</div>
      </div>
      <div tabindex="0" class="el-slider__button-wrapper" :style="{left: centerPosition+'%'}">
        <div
          class="el-tooltip el-slider__button"
          aria-describedby="el-tooltip-6137"
          @touchstart="onButtonDowm"
          @mousedown="onButtonDowm"
          id="slider-center"
        ></div>
        <div class="tips" v-if="dragging && targetEle.id==='slider-center'">{{posiObj.center}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    max: {
      type: Number,
      default: 100,
    },
    min: {
      type: Number,
      default: 0,
    },
    step: {
      default: 1,
      type: Number,
    },
    value: {
      type: Object,
      default: () => {
        return {
          left: null,
          right: null,
          center: null,
        };
      },
    },
  },
  data() {
    return {
      targetEle: null,
      dragging: false,
      isClick: false,
      currentX: 0,
      startX: 0,
      startPosition: 0,
      newPosition: null,
      posiObj: {
        left: +this.value.left,
        right: +this.value.right,
        center: +this.value.center,
      },
      leftPosition: 0,
      rightPosition: 0,
      centerPosition: 0,
    };
  },
  watch: {
    value: {
      handler(val, oldVal) {
        if (this.dragging) {
          return;
        }
        this.setValues();
      },
      deep: true,
    },
  },
  mounted() {
    this.setValues();
  },
  methods: {
    setValues() {
      if (this.min > this.max) {
        console.error("[Error][Slider]min should not be greater than max.");
        return;
      }
      const val = this.value;
      console.log("==value===", val.left, val.right, val.center);
      if (
        +val.left > this.posiObj.center ||
        +val.right < this.posiObj.center ||
        isNaN(+val.left) ||
        isNaN(+val.center) ||
        isNaN(+val.right) ||
        val.left === "" ||
        val.right === "" ||
        val.center === ""
      ) {
        console.error("[Error][Slider]number range is not valid.");
        return;
      }
      if (val) {
        if (+val.left < this.min || isNaN(+val.left)) {
          this.posiObj.left = this.min;
          this.updateLeft();
          console.log("this.posiObj.left=", this.posiObj.left);
          this.$emit("input", this.posiObj);
        } else if (+val.right > this.max || isNaN(+val.right)) {
          this.posiObj.right = this.max;
          this.updateRight();
          console.log("this.posiObj.right=", this.posiObj.left);
          this.$emit("input", this.posiObj);
        } else {
          // this.posiObj.left = parseInt(this.posiObj.left)
          this.posiObj.left = +val.left;
          this.posiObj.right = +val.right;
          this.posiObj.center = +val.center;
          this.updateLeft();
          this.updateRight();
          this.updateCenter();
          this.$emit("input", this.posiObj);
        }
      }
    },
    updateLeft() {
      this.leftPosition =
        ((this.posiObj.left - this.min) / (this.max - this.min)) * 100;
    },
    updateRight() {
      this.rightPosition =
        ((this.posiObj.right - this.min) / (this.max - this.min)) * 100;
    },
    updateCenter() {
      this.centerPosition =
        ((this.posiObj.center - this.min) / (this.max - this.min)) * 100;
    },
    displayTooltip() {
      this.$refs.tooltip && (this.$refs.tooltip.showPopper = true);
    },
    hideTooltip() {
      this.$refs.tooltip && (this.$refs.tooltip.showPopper = false);
    },
    precision() {
        let precisions = [this.min, this.max, this.step].map(item => {
          let decimal = ('' + item).split('.')[1];
          return decimal ? decimal.length : 0;
        });
        return Math.max.apply(null, precisions);
    },
    onDragStart(e) {
      this.dragging = true;
      this.isClick = true;
      this.displayTooltip();
      this.targetEle = document.getElementById(e.target.id);
      if (e.type === "touchstart") {
        e.clientX = e.touches[0].clientX;
      }
      this.startX = e.clientX;
      this.startPosition = this.getStartPositinById(this.targetEle.id);
      this.newPosition = this.startPosition;
      console.log("startPosition=", this.startPosition);
    },
    onButtonDowm(e) {
      e.preventDefault();
      this.onDragStart(e);
      window.addEventListener("mousemove", this.onDragging);
      window.addEventListener("touchmove", this.onDragging);
      window.addEventListener("mouseup", this.onDragEnd);
      window.addEventListener("touchend", this.onDragEnd);
    },
    onDragging(e) {
      if (this.dragging) {
        this.isClick = false;
        if (e.type === "touchmove") {
          e.clientX = e.touches[0].clientX;
        }
        this.currentX = e.clientX;
        const width = this.$refs.slider["clientWidth"];
        const diff = ((this.currentX - this.startX) / width) * 100;
        const newPosition = this.startPosition + diff;
        this.newPosition = newPosition;
        this.setPositionById(this.targetEle.id, newPosition);
      }
    },
    setPositionById(id, newPosition) {
      if (id === "slider-right") {
        this.setRightPosi(newPosition);
      } else if (id === "slider-left") {
        this.setLeftPosi(newPosition);
      } else if (id === "slider-center") {
        this.setCenterPosi(newPosition);
      }
    },
    getStartPositinById(id) {
      switch (id) {
        case "slider-right":
          return this.rightPosition;
        case "slider-left":
          return this.leftPosition;
        case "slider-center":
          return this.centerPosition;
      }
    },
    setRightPosi(newPosition) {
      if (newPosition === null || isNaN(newPosition)) return;
      if (newPosition < this.centerPosition) {
        newPosition = this.centerPosition;
      } else if (newPosition > 100) {
        newPosition = 100;
      }

      const lengthPerStep = (this.step / (this.max - this.min)) * 100;
      const steps = Math.round(newPosition / lengthPerStep);
      let value =
        steps * lengthPerStep * (this.max - this.min) * 0.01 + this.min;
      value = parseFloat(value.toFixed(this.precision));
      this.posiObj.right = value;
      this.updateRight();
      this.$emit("input", this.posiObj);
    },
    setLeftPosi(newPosition) {
      if (newPosition === null || isNaN(newPosition)) return;
      if (newPosition < 0) {
        newPosition = 0;
      } else if (newPosition > this.centerPosition) {
        newPosition = this.centerPosition;
      }
      const lengthPerStep = (this.step / (this.max - this.min)) * 100;
      const steps = Math.round(newPosition / lengthPerStep);
      let value =
        steps * lengthPerStep * (this.max - this.min) * 0.01 + this.min;
      value = parseFloat(value.toFixed(this.precision));
      this.posiObj.left = value;
      this.updateLeft();
      this.$emit("input", this.posiObj);
    },
    setCenterPosi(newPosition) {
      if (newPosition === null || isNaN(newPosition)) return;
      if (newPosition < this.leftPosition) {
        newPosition = this.leftPosition;
      } else if (newPosition > this.rightPosition) {
        newPosition = this.rightPosition;
      }

      const lengthPerStep = (this.step / (this.max - this.min)) * 100;
      const steps = Math.round(newPosition / lengthPerStep);
      let value =
        steps * lengthPerStep * (this.max - this.min) * 0.01 + this.min;
      value = parseFloat(value.toFixed(this.precision));
      this.posiObj.center = value;
      this.updateCenter();
      this.$emit("input", this.posiObj);
    },
    onDragEnd(e) {
      if (this.dragging) {
        // this.dragging = false;
        /*
         * 防止在 mouseup 後立即觸發 click，導致滑塊有幾率產生一小段位移
         * 不使用 preventDefault 是因為 mouseup 和 click 沒有註冊在同一個 DOM 上
         */
        console.log("觸發onDragEnd");
        setTimeout(() => {
          this.dragging = false;
          if (!this.isClick) {
            this.setPositionById(this.targetEle.id, this.newPosition);
          }
        }, 0);
        window.removeEventListener("mousemove", this.onDragging);
        window.removeEventListener("touchmove", this.onDragging);
        window.removeEventListener("mouseup", this.onDragEnd);
        window.removeEventListener("touchend", this.onDragEnd);
      }
    },
  },
};
</script>

<style scoped>
.el-slider__runway {
  width: 100%;
  height: 4px;
  margin: 16px 0;
  background-color: #e4e7ed;
  border-radius: 3px;
  position: relative;
  cursor: pointer;
  vertical-align: middle;
}
.el-slider__bar {
  height: 4px;
  background-color: #91d5ff;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
  position: absolute;
}
.el-slider__button-wrapper {
  height: 20px;
  width: 20px;
  position: absolute;
  z-index: 1001;
  top: -8px;
  transform: translateX(-50%);
  background-color: transparent;
  text-align: center;
  user-select: none;
  line-height: normal;
  display: flex;
  align-items: center;
  justify-content: center;
}
/* .el-slider__button-wrapper .el-tooltip,
.el-slider__button-wrapper:after {
  display: inline-block;
  vertical-align: middle;
} */
.el-slider__button {
  width: 14px;
  height: 14px;
  border: 2px solid #91d5ff;
  background-color: #fff;
  border-radius: 50%;
  transition: 0.2s;
  user-select: none;
}
.tips {
  min-width: 20px;
  min-height: 20px;
  padding: 2px 5px;
  font-size: 14px;
  background-color: rgba(0, 0, 0, 0.8);
  position: absolute;
  top: -22px;
  border-radius:4px;
  color: #fff;
}
</style>
